export default {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
  AUDIO: 'AUDIO',
  DOCUMENT: 'DOCUMENT',
  COLLECT: 'Collect',
  TYPING: 'TYPING',
  MESSAGE: 'MESSAGE',
  CAROUSEL: 'CAROUSEL',
  WEBVIEW: 'WEBVIEW',
  BIGGER_FILE: 'bigger',
  MALICIOUS_FILE: 'malicious',
  MEDIA_ERROR_MESSAGE: 'Media Error',
};
